type ScavengerListItem = {
    name: string,
    objective: string,
    points: number,
    image: string,
    lat: number,
    lng: number
}

const scavengerList: ScavengerListItem[] = [
    {
        name: "Drillfield Sunset Picture",
        objective: "Take a picture of the drillfield at sunset.",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.22758,
        lng: -80.42197,
        found: false
    },
    {
        name: "Duck Pond Picture",
        objective: "Take a picture of yourself with ducks at the Duck Pond",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.22582,
        lng: -80.42819,
        found: false
    },
    {
        name: "Beamer Statue Picture",
        objective: "Take a picture of yourself at the Frank Beamer Statue",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.21914,
        lng: -80.41897,
        found: false
    },
    {
        name: "Pylons Picture",
        objective: "Take a picture of yourself sitting on the edge at the Pylons",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.22878,
        lng: -80.42057,
        found: false
    },
    {
        name: "D2 Hokie Bird Statue Picture",
        objective: "Take a picture of yourself with the Hokie Bird Statue by D2",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.22436,
        lng: -80.42061,
        found: false
    },
    {
        name: "Market Picture",
        objective: "Take a picture of yourself at the Farmer's Market",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.22927,
        lng: -80.41472,
        found: false
    },
    {
        name: "Torg Brige Picture",
        objective: "Take a picture of yourself at the Torgerson Bridge",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.22945,
        lng: -80.41945,
        found: false
    },
    {
        name: "Burruss Picture",
        objective: "Take a picture of yourself in front of Burruss",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.22844,
        lng: -80.42301,
        found: false
    },
    {
        name: "Horticulture Garden Picture",
        objective: "Take a picture of yourself inside of Hahn Horticulture Garden",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.21917,
        lng: -80.42418,
        found: false
    },
    {
        name: "Caldwell Statue picture",
        objective: "Take a picture of yourself with the William Addison Caldwell statue",
        points: 2,
        image: "https://firebasestorage.googleapis.com/v0/b/bucketlist-90b4c.appspot.com/o/default.jpg?alt=media&token=cfd75f88-2680-43ca-b69e-377690870da5",
        lat: 37.23019,
        lng: -80.41902,
        found: false
    }
];

export default scavengerList;
